export default __webpack_public_path__ + "static/media/nissan.9958cf3a.jpg";